// QUICK CONTACT

// Import GSAP
import {gsap} from 'gsap';

/* eslint-disable */
let searchButton = $('.search-button');
let searchButtonCloseMobile = $('.close-search-mobile');
let searchButtonCloseDesktop = $('.close-search-desktop');
let searchOverlay = $('.search-popup-overlay');
let search = $('.search-popup');

// Quote Overlay
function searchOverlayFunction (){
  // Animation timeline
  let searchOverlayTL = gsap.timeline({paused:true});

  searchOverlayTL
    .to(searchOverlay, 0, {autoAlpha: 0, delay: 0})
    .to(searchOverlay, 0.5, {autoAlpha: 1, delay: 0});
  return searchOverlayTL

}
// Store a reference to the timeline that was created to control it later
let searchOverlayController = searchOverlayFunction ();

// Quote Overlay
function searchPopup(){
  // Animation timeline
  let searchPopupTL = gsap.timeline({paused:true});

  searchPopupTL
    .to(search, 0, {autoAlpha: 0, delay: 0})
    .to(search, 0.5, {autoAlpha: 1, delay: 0});
  return searchPopupTL

}
// Store a reference to the timeline that was created to control it later
let searchPopupController = searchPopup();


$(searchButton).on('click', function(e){
  e.preventDefault();
  // Reverse navigation open animation
  searchOverlayController.play();
  searchPopupController.play();

  // Re-enable scrolling
  $('body').addClass('scroll-disabled'); // Desktop
  $('body').bind('touchmove'); // Mobile

});

$(searchOverlay).on('click', function(){
  // Reverse navigation open animation
  searchOverlayController.timeScale(2).reverse();
  searchPopupController.timeScale(2).reverse();

  // Re-enable scrolling
  $('body').removeClass('scroll-disabled'); // Desktop
  $('body').unbind('touchmove'); // Mobile
});

$(searchButtonCloseDesktop).on('click', function(){
  // Reverse navigation open animation
  searchOverlayController.timeScale(2).reverse();
  searchPopupController.timeScale(2).reverse();

  // Re-enable scrolling
  $('body').removeClass('scroll-disabled'); // Desktop
  $('body').unbind('touchmove'); // Mobile
});

$(searchButtonCloseMobile).on('click', function(){
  // Reverse navigation open animation
  searchOverlayController.timeScale(2).reverse();
  searchPopupController.timeScale(2).reverse();
});
/* eslint-enable */
